import { render, staticRenderFns } from "./MainNavigationMenu.vue?vue&type=template&id=eed9c058&scoped=true"
import script from "./MainNavigationMenu.vue?vue&type=script&lang=js"
export * from "./MainNavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationMenu.vue?vue&type=style&index=0&id=eed9c058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed9c058",
  null
  
)

export default component.exports